/**
 * Черновик формы входа клиента в мобильном embed: при переходе на юридический документ
 * (оферта/соглашение/политика) React Router размонтирует страницу входа, и без черновика
 * введённый телефон/логин терялись бы. Храним только в памяти вкладки (не в storage):
 * пароль не сохраняется, после успешного входа черновик очищается.
 */
export type ClientSignInDraft = {
  authTab: 'call' | 'password';
  callPhoneInput: string;
  loginEmail: string;
  accountPhone: string;
};

let draft: ClientSignInDraft | null = null;

export function saveClientSignInDraft(next: ClientSignInDraft): void {
  draft = { ...next };
}

export function readClientSignInDraft(): ClientSignInDraft | null {
  return draft ? { ...draft } : null;
}

export function clearClientSignInDraft(): void {
  draft = null;
}
